export default __webpack_public_path__ + "static/media/sendMessage.130a727f.svg";